module.exports = __webpack_public_path__ + "img/GAME_LINKRIBBON.19c874f9.png";